export default __webpack_public_path__ + "static/media/pic5.51e67885.png";